import $ from 'jquery';
import _ from 'lodash';
import * as popupActions from '../actions/A_Popups';
import {store} from '../main';
import * as actionTypes from '../constants/actionTypes';
import * as misc from './../misc';
import { is } from 'immutable';

const dontShowErrorPopupFor = [
  "/pay/",
  "TwoFactorAuthentication/SendAuthenticationRequest",
];

function handleHttpError(response) {
  if (response.status === 401) { // un-authorized
    store.dispatch({type: actionTypes.LOGOUT, payload: null});
    return response;
  }
  if (response.status === 400) { // bad request
    return response.json()
      .then(json => {
        if (!(response && response.url && dontShowErrorPopupFor.some(urlPart => response.url.includes(urlPart)))) {
          checkApiError(json, store.dispatch); // don't render error popup on pay
        }
        //console.log(400, json);
        let errorMessage = json.error || json.errorMessage || json.message
          || (json.errors && Array.isArray(json.errors) ? json.errors.join(',') : null);
        return Promise.resolve({__error__: true, __errorMessage__: errorMessage});
      });
  }
  if (!response.ok) {
    return response.json()
      .then(json => Promise.reject(json ? json.message : response.statusMessage));
  }

  return response;
}

export function KvConfig() {
  return document.kvConfig;
}

export const getRenderErrorMesssage = (response) => {
  return response.__errorMessage__ || response.error || response.__error__ || response + "" || "An error occurred"
}

export function getManaging() {
  const {userExistsIn} = store.getState().auth;
  let managing = (userExistsIn.kitchen && userExistsIn.bathroom && window.managing
    ? window.managing
    : (userExistsIn.kitchen ? 'KitchenDB' : 'BathDB'));
  return managing;
}

export  function asCustomerSaved() {
  const json = localStorage.getItem('asCustomer');
  if (!json)
    return null;
  return JSON.parse(json);
}

/**
 * Return an object containing all of the details need to perform API requests on the backend.
 */
export function getApiConfig(api) {
  const {apiUrl} = document.kvConfig;
  const apiPath = `${apiUrl || ''}/${api ? `api/${api}` : ''}`;
  const antiForgeryToken = $('input[name=__RequestVerificationToken]').val() || '';
  const cors = !!apiUrl;
  let controller = new AbortController();

  return {
    abort() {
      controller.abort();
    },
    get(endpoint) {
      let url = `${apiPath}${endpoint || ''}`;
      if (url.startsWith('//')) {
        url = url.substring(1);
      }

      const headers = {
        'Accept': 'application/json',
        'x-as-user-id': misc.monads.NN(asCustomerSaved(), _ => _.userId, 0),
        'x-as-customer-id': misc.monads.NN(asCustomerSaved(), _ => _.customerBaseId, 0),
        'x-database-connection': getManaging()
      };

      return fetch(url, {
        headers: headers,
        credentials: cors ? 'include' : 'same-origin',
        signal: controller.signal
      })
        .then(handleHttpError)
        .then(response => getResponse(response))
        .catch(reason => Promise.reject(reason));
    },

    delete(endpoint) {
      let url = `${apiPath}${endpoint || ''}`;
      if (url.startsWith('//')) {
        url = url.substring(1);
      }
      return fetch(url, {
        headers: {
          'Accept': 'application/json',
          'x-as-user-id': misc.monads.NN(asCustomerSaved(), _ => _.userId, 0),
          'x-as-customer-id': misc.monads.NN(asCustomerSaved(), _ => _.customerBaseId, 0),
          'x-database-connection': getManaging()
        },
        credentials: cors ? 'include' : 'same-origin',
        method: 'delete',
        signal: controller.signal,
      })
        .then(handleHttpError)
        .then(response => getResponse(response))
        .catch(reason => Promise.reject(reason));

    },

    // POSTs require the current value of the antiforgery token.
    post(data, endpoint = "", method = "post") {
      let url = `${apiPath}/${endpoint}`;
      if (url.startsWith('//')) {
        url = url.substring(1);
      }
      const isFormData = Object.prototype.toString.call(data) === '[object FormData]';
      const headers = {
        'Accept': 'application/json',
        'x-antiforgery-token': antiForgeryToken,
        'x-as-user-id': misc.monads.NN(asCustomerSaved(), _ => _.userId, 0),
        'x-as-customer-id': misc.monads.NN(asCustomerSaved(), _ => _.customerBaseId, 0),
        'x-database-connection': getManaging()
      };

      if (!isFormData) {
        headers['Content-Type'] = 'application/json';
      }

      return fetch(url, {
        method,
        body: isFormData ? data : JSON.stringify(data),
        headers: new Headers(headers),
        credentials: cors ? 'include' : 'same-origin',
        signal: controller.signal,
      })
        .then(handleHttpError)
        .then(response => getResponse(response))
        .catch(reason => Promise.reject(reason));
    }
  };
}

function getResponse(response) {
  if (!response)
    return null;
  if (response.json)
    return response.json();
  return response;
}

export function checkApiError(response, dispatch) {
  let errorMessage = response.error || response.errorMessage
      || (response.errors && Array.isArray(response.errors) ? response.errors.join(',') : null);
  if (!errorMessage) {
    return ;
  }

  if(_.startsWith(errorMessage, 'Execution Timeout Expired'))
    errorMessage = "The system has exceeded the allowed execution time due to heavy load.  Please wait a moment and try again.";

  dispatch(popupActions.errorBox_Show({
    text: errorMessage,
    isRightButtonVisible: true,
    rightButtonText: 'OK'
  }));
}

export function isQFOrLocal() {
  const parts = location.hostname.split('.');
  const domain = parts.length > 1 ? parts.slice(-2, -1) : parts;
  return /(gfd)|(localhost)|(quotesflooring)/i.test(domain[0]);
}

export const IS_QKB_PRODUCTION = window.location.hostname === "quotekitchenandbath.com";
export const IS_LIXIL_SERVERS = window.location.hostname === "qkandb.net" || window.location.hostname === "kbquote.com";
export const IS_QC_SERVERS = IS_QKB_PRODUCTION || window.location.hostname === "quotekandb.com" || window.location.hostname === "quotesflooring.com";

export function saveFile(blobType, byteArray, fileName){
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  const blob = new Blob([byteArray], {
    type: blobType
  });
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}

window.getApiConfig = getApiConfig;
